import { AxiosRequestConfig } from 'axios';

import {
  MOKA_SERVICE_HOST,
  BACKEND_HOST,
  MOKA_GOAUTH_SERVICE,
  MOKA_OPEN_API_HOST,
} from '../../api/constants';

function redirectLegacyApis(config: AxiosRequestConfig) {
  if ((config.url as string).startsWith(MOKA_SERVICE_HOST!)) {
    config.url = (config.url as string).replace(
      MOKA_SERVICE_HOST!,
      MOKA_GOAUTH_SERVICE!
    );
  } else if ((config.url as string).startsWith(BACKEND_HOST!)) {
    config.url = (config.url as string).replace(
      BACKEND_HOST!,
      MOKA_GOAUTH_SERVICE!
    );
  } else if ((config.url as string).startsWith(MOKA_OPEN_API_HOST!)) {
    config.url = (config.url as string).replace(
      MOKA_OPEN_API_HOST!,
      MOKA_GOAUTH_SERVICE!
    );
  }

  return config;
}

export default redirectLegacyApis;
